import { LinksCollectionStoryblok } from '@monoimin/sb-types';

export const isLinksCollection = (
  value: unknown
): value is LinksCollectionStoryblok => {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'component' in value &&
      value.component === 'linksCollection'
  );
};

export default isLinksCollection;
